import { useGetAllTagTypes } from "./useGetAllTagTypes";
import { useGetAllTagValues } from "./useGetAllTagValues";
import { TagContext } from "../../../types/tag";

/**
 * Hook to provide tag context (types and values) for the new JSON-based tag system
 */
export const useTagContext = (context?: TagContext) => {
    const { tagTypes = [], isLoading: tagTypesLoading } = useGetAllTagTypes({
        ...(context && { context }),
    });

    const { data: tagValuesData, isLoading: tagValuesLoading } = useGetAllTagValues();
    const tagValues = tagValuesData?.tagValues || [];

    return {
        tagTypes,
        tagValues,
        isLoading: tagTypesLoading || tagValuesLoading,
        isReady: !tagTypesLoading && !tagValuesLoading,
    };
};
